import AccountService from "./Model/AccountService"
import Service, { IsServiceActive } from "./Model/Service"
import TestToBePerform from "../LabService/LabServiceModel/TestToBePerform"
import { ServiceCode } from "../LookupCodes/ServiceCode"

export interface IDrugService extends Service {
  isDOT: boolean
  isFlex: boolean
  isPOCT: boolean
  isDOTUrine: boolean
  isDOTSalive: boolean
  isNonDOTUrine: boolean
  isNonDOTSaliva: boolean
  isMarketplace: boolean
  tests: TestToBePerform[]
  hasTests: boolean
  isActive: boolean
}

export const IsServiceDrug = (data: Service) => {
  return [
    ServiceCode.DrugDOTUrine,
    ServiceCode.DrugDOTOral,
    ServiceCode.DrugNonDOTUrine,
    ServiceCode.DrugNonDOTOral,
  ].includes(data.FFServiceCode as ServiceCode)
}

export const IsServiceDrugDOT = (data: Service) => {
  return data.DOT && IsServiceDrug(data)
}

export const IsServiceDrugNonDOT = (data: Service) => {
  return !data.DOT && IsServiceDrug(data)
}

export const IsServiceDrugDOTUrine = (data: Service) => {
  return data.DOT && data.FFServiceCode === ServiceCode.DrugDOTUrine
}

export const IsServiceDrugDOTSaliva = (data: Service) => {
  return data.DOT && data.FFServiceCode === ServiceCode.DrugDOTOral
}

export const IsServiceDrugNonDOTUrine = (data: Service) => {
  return !data.DOT && data.FFServiceCode === ServiceCode.DrugNonDOTUrine
}

export const IsServiceDrugNonDOTSaliva = (data: Service) => {
  return !data.DOT && data.FFServiceCode === ServiceCode.DrugNonDOTOral
}

export function IsServicePOCT(data: Service): boolean {
  return data.FFServiceCode === ServiceCode.POCT
}

export function IsServiceFLEX(data: Service): boolean {
  return data.FFServiceCode === ServiceCode.FLEX
}

const DrugService = (
  service: Service,
  serviceTests: TestToBePerform[],
  orderableAccountServices?: AccountService[]
): IDrugService => {
  const isDOT = IsServiceDrugDOT(service)
  const isDOTUrine = IsServiceDrugDOTUrine(service)
  const isDOTSalive = IsServiceDrugDOTSaliva(service)
  const isNonDOTUrine = IsServiceDrugNonDOTUrine(service)
  const isNonDOTSaliva = IsServiceDrugNonDOTSaliva(service)
  const isFlex = IsServiceFLEX(service)
  const isPOCT = IsServicePOCT(service)
  const isMarketplace = service.Marketplace
  const tests = serviceTests || []
  const isActive = IsServiceActive(service, orderableAccountServices || [])

  return {
    ...service,
    isDOT,
    isFlex,
    isPOCT,
    isDOTUrine,
    isDOTSalive,
    isNonDOTUrine,
    isNonDOTSaliva,
    isMarketplace,
    tests,
    hasTests: tests.length > 0,
    isActive,
  }
}

export default DrugService
